import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Register() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    role: 'Employee',
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { dispatch } = useAuth();

  // ✅ Allowed domains list (Frontend pre-validation)
  const allowedDomains = ['pnpclaos.com'];

  // ✅ Email domain checker
  const isAllowedEmail = (email) => {
    const domain = email.split('@')[1]?.toLowerCase();
    return allowedDomains.includes(domain);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // ✅ Pre-validate email domain before sending to backend
    if (!isAllowedEmail(form.email)) {
      setError('Please use PNPC email to register!');
      return;
    }

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/register`, form);
      // Auto login after register
      dispatch({ type: 'REGISTER', payload: res.data });
      navigate('/tickets');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '400px' }}>
      <h2 className="mb-4">Register</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          className='form-control mb-3'
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          className='form-control mb-3'
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          className='form-control mb-3'
          name="password"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <select name="role" value={form.role} onChange={handleChange} className='form-select mb-3'>
          <option value="Employee">Employee</option>
        </select>
        <button type="submit" className='btn btn-secondary w-100'>Register</button>            
      </form>
    </div>
  );
}
